/* eslint-disable import/no-unresolved */
import React from 'react';
import { styled, __UNSAFE_SPACE_TO_DIMSUM } from '@elliemae/ds-system';
import { describe, PropTypes } from '@elliemae/ds-props-helpers';
import { Grid } from '@elliemae/ds-grid';
import { DSMobileSeparator as MobileSeparator } from '../MobileSeparator/index.js';

const Bar = styled.div`
  display: flex;
  overflow: auto;
  height: 40px;
  background-color: ${(props) => props.theme.colors.neutral['000']};
  padding-left: ${(props) => __UNSAFE_SPACE_TO_DIMSUM(props.theme.space.xs)};
  & > * {
    flex-shrink: 0;
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;

const Separator = styled.div`
  & > * {
    margin: 0;
  }
`;

const DSMobileFilterbar = ({ children }) => (
  <Grid rows={['auto', 'auto']} data-testid="filter-bar-wrapper">
    <Bar>{children}</Bar>
    <Separator>
      <MobileSeparator margin="xxs" color={['neutral', '300']} />
    </Separator>
  </Grid>
);

const filterbarProps = {
  children: PropTypes.element.description('FilterBar Items').isRequired,
};

DSMobileFilterbar.displayName = 'DSMobileFilterbar';
const FilterbarWithSchema = describe(DSMobileFilterbar);
FilterbarWithSchema.propTypes = filterbarProps;

export { DSMobileFilterbar, FilterbarWithSchema };
